import React, { useEffect, useState } from 'react';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import { Text, RichText, Image, Link } from '@sitecore-jss/sitecore-jss-react';
import './tvsHeader.scss';
import '../TvsCountryDropDown/TvsCountryDropDown.scss';
import { Placeholder } from '@sitecore-jss/sitecore-jss-react';
import { withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';

function TvsHeader(props) {
  const isLogoRequired = props?.fields?.ShowLogo;
  const [menuOpen, setMenuOpen] = useState(false);

  // Apply or remove overflow hidden on body
  useEffect(() => {
    if (menuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }
    return () => {
      // Clean up on component unmount
      document.body.style.overflow = 'auto';
    };
  }, [menuOpen]);

  const handleToggle = () => {
    setMenuOpen((prev) => !prev);
  };

  return (
    <div className="header-container">
      <Navbar
        collapseOnSelect
        expand="lg"
        className="header roboto-medium"
        fixed="top"
        onToggle={handleToggle}
        expanded={menuOpen} // Control the state of the Navbar
      >
        <Container fluid>
          <Navbar.Toggle aria-controls="responsive-navbar-nav" />
          {props?.fields?.ShowLogo?.value === true && (
            <Navbar.Brand
              href={props?.fields.LogoUrl.value.url}
              target={props?.fields.LogoUrl.value.target}
            >
              <Image field={props?.fields.LogoImage} />
            </Navbar.Brand>
          )}
          <div className="menu-wrapper">
            <Nav className="d-none d-lg-flex language-wrap">
              <>
                {props?.fields?.StickyMenuList.map(
                  (childItem, i) =>
                    childItem?.fields?.ShowOnDesktop?.value === true && (
                      <Nav.Link
                        href={childItem?.fields?.NavigationLink?.value?.url}
                        target={childItem?.fields?.NavigationLink?.value?.target}
                        key={i}
                      >
                        <span
                          className={childItem?.fields?.NavigationClassName?.value + ' me-2'}
                        ></span>
                        {childItem?.fields?.NavigationTitle?.value}
                      </Nav.Link>
                    )
                )}
                <div className="country">
                  <Placeholder
                    name="jss-countryDropdown"
                    rendering={props.sitecoreContext.route}
                    className={'countryHeader-dropdown'}
                  />
                </div>
              </>
            </Nav>
            <Navbar.Collapse id="responsive-navbar-nav">
              <Nav>
                {props?.fields?.MenuItems?.map((item, index) => {
                  const showOnDesktop = item?.fields?.ShowOnDesktop?.value === true;
                  const showOnMobile = item?.fields?.ShowOnMobile?.value === true;
                  const hasChildLevelNavigation =
                    item?.fields?.HasChildLevelNavigation?.value === true;

                  if (showOnDesktop) {
                    if (hasChildLevelNavigation) {
                      return (
                        <NavDropdown
                          title={item?.fields?.NavigationTitle?.value}
                          id="collapsible-nav-dropdown"
                          key={index}
                          className="nav-item dropdown"
                        >
                          {item?.fields?.ChildMenu?.map((dropdownItem, idx) => (
                            <NavDropdown.Item
                              href={dropdownItem?.fields?.NavigationLink?.value?.url}
                              target={dropdownItem?.fields?.NavigationLink?.value?.target}
                              className="roboto-regular"
                              key={idx}
                            >
                              {dropdownItem?.fields?.NavigationTitle?.value}
                            </NavDropdown.Item>
                          ))}
                        </NavDropdown>
                      );
                    } else {
                      return (
                        <Nav.Link
                          href={item?.fields?.NavigationLink?.value?.url}
                          target={item?.fields?.NavigationLink?.value?.target}
                          key={index}
                        >
                          {item?.fields?.ShowNavigationImageInsteadOfName?.value === true ? (
                            <Image field={item?.fields?.NavigationImage} />
                          ) : (
                            item?.fields?.NavigationTitle?.value
                          )}
                        </Nav.Link>
                      );
                    }
                  } else {
                    if (hasChildLevelNavigation) {
                      return (
                        <ul key={index} className="visible-xs sub-menu">
                          {item?.fields?.ChildMenu?.map((dropdownItem, idx) => (
                            <li key={idx}>
                              <a
                                href={dropdownItem?.fields?.NavigationLink?.value?.url}
                                target={dropdownItem?.fields?.NavigationLink?.value?.target}
                              >
                                {dropdownItem?.fields?.NavigationTitle?.value}
                              </a>
                            </li>
                          ))}
                        </ul>
                      );
                    } else {
                      return (
                        <Nav.Link
                          className="visible-xs"
                          href={item?.fields?.NavigationLink?.value?.url}
                          target={item?.fields?.NavigationLink?.value?.target}
                          key={index}
                        >
                          {item?.fields?.NavigationTitle?.value}
                        </Nav.Link>
                      );
                    }
                  }
                })}
                {/* Add more Nav.Link items if needed */}
                <div className="d-block d-md-block d-sm-block d-lg-none country-mobile">
                  <h3>International Websites:</h3>
                  <div className="country">
                    <Placeholder
                      name="jss-MobcountryDropdown"
                      rendering={props.sitecoreContext.route}
                      className={'countryHeader-dropdown'}
                    />
                  </div>
                </div>
              </Nav>
              {/* Add more Nav components if needed */}
              <Nav className="cart-nav d-none d-sm-flex">
                {props?.fields?.IconsMenu?.map((iconItem, i) => (
                  <Nav.Link href={iconItem?.fields?.NavigationLink?.value.url} key={i}>
                    <span className={iconItem?.fields?.NavigationClassName?.value}></span>
                  </Nav.Link>
                ))}
              </Nav>
            </Navbar.Collapse>
          </div>
        </Container>
      </Navbar>
      <Nav
        defaultActiveKey="/home"
        as="ul"
        className="d-lg-none secondaryMenu d-flex justify-content-around"
      >
        {props?.fields?.StickyMenuList.map(
          (mobileItem, i) =>
            mobileItem?.fields?.ShowOnMobile?.value === true && (
              <Nav.Item as="li" key={i}>
                <Nav.Link
                  href={mobileItem?.fields?.NavigationLink?.value?.url}
                  target={mobileItem?.fields?.NavigationLink?.value?.target}
                  className="roboto-regular text-center"
                >
                  <span className={mobileItem?.fields?.NavigationClassName?.value}></span>
                  {mobileItem?.fields?.NavigationTitle?.value}
                </Nav.Link>
              </Nav.Item>
            )
        )}
      </Nav>
    </div>
  );
}
export default withSitecoreContext()(TvsHeader);
